var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoModal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2606_2650)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9974 29.3332C8.6334 29.3332 2.66406 23.3638 2.66406 15.9998C2.66406 8.63584 8.6334 2.6665 15.9974 2.6665C23.3614 2.6665 29.3307 8.63584 29.3307 15.9998C29.3307 23.3638 23.3614 29.3332 15.9974 29.3332ZM15.9974 26.6665C18.8264 26.6665 21.5395 25.5427 23.5399 23.5423C25.5403 21.5419 26.6641 18.8288 26.6641 15.9998C26.6641 13.1709 25.5403 10.4578 23.5399 8.45737C21.5395 6.45698 18.8264 5.33317 15.9974 5.33317C13.1684 5.33317 10.4553 6.45698 8.45492 8.45737C6.45454 10.4578 5.33073 13.1709 5.33073 15.9998C5.33073 18.8288 6.45454 21.5419 8.45492 23.5423C10.4553 25.5427 13.1684 26.6665 15.9974 26.6665ZM14.6641 19.9998H17.3307V22.6665H14.6641V19.9998ZM14.6641 9.33317H17.3307V17.3332H14.6641V9.33317Z",
    fill: "#3B82F6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2606_2650"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoModal);
export default __webpack_public_path__ + "static/media/info_modal.1e2d9b67c8731c1ad0c6ef9676b708a1.svg";
export { ForwardRef as ReactComponent };